<template>
    <div>
 <div class="imgpost" ><el-image style="width: 100%;" :src="require('../../public/static/pageFourth/top1.png')"  fit="fit"></el-image></div>
 <div>
    <div v-for="item in news" :key="item.id" class="newsMain">
        <div style="display: flex;width: 60%;margin: 30px auto;padding-bottom: 30px;border-bottom:2px solid #E1E6EA; ;" @click="goNews(item.link)" >

          
            <div style="width: 35%;"><el-image :src="item.url"  fit="fit" style="width:100%;"></el-image></div>
            <div class="item2" style="width: 60%;">
                <div style="font-size: 24px;color: #374352;">
  <div style="width: 100%;  white-space: nowrap;   
  overflow: hidden;     
  text-overflow: ellipsis;">{{ item.title }}</div>
                      <div style="font-size: 16px;color: #7D858F;margin-top: 20px;display: -webkit-box;-webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis; line-height: 30px;">{{ item.content }}</div>
                </div>
            
                <div>{{ item.time }}</div>

            </div>
     
        </div>
    </div>

 </div>
 </div>
 </template>
   <script>
   export default {
     name: 'PageOne',// 使用多词名称
 
     data() {
       return {
         activeName: 'second',
         news:[
           {url:require('../../public/static/pageFourth/news1.png'),title:"三年合作成果硬核！南沙携手香港再出发",content:'《南沙方案》落地三年，广州南沙与香港的合作迈入全新阶段，两地协同发展呈现蓬勃生机。',time:'2025-09-17',link:'http://www.gzns.gov.cn/nsdt/nsyw/content/post_10451424.html'},
           {url:require('../../public/static/pageFourth/news1.png'),title:"南沙区委常委会、南沙开发区（自贸区南沙片区）党工委召开会议 部署传承弘扬伟大抗战精神和作风建设等工作",content:'9月18日，南沙区委常委会、南沙开发区（自贸区南沙片区）党工委召开会议，套开区委理论学习中心组学习会，深入学习贯彻习近平总书记在纪念中国人民抗日战争暨世界反法西斯战争胜利80周年大会和招待会上的重要讲话精神。',time:'2025-09-22',link:'http://www.gzns.gov.cn/nsdt/nsyw/content/post_10457103.html'},
           {url:require('../../public/static/pageFourth/news1.png'),title:"游艇行业大咖齐聚南沙，共话产业发展新蓝图",content:'9月30日下午，粤港澳大湾区游艇业交流会在广州南沙成功举行。',time:'2025-10-09  ',link:'http://www.gzns.gov.cn/zwgk/zwdt/content/post_10472897.html'},
           {url:require('../../public/static/pageFourth/news1.png'),title:"这个假日，我们记下了一些瞬间",content:'每一次俯身，都为信赖。每一次向前，都为期待。假日“警”色浓，我们的故事还在继续……',time:'2025-10-10 ',link:'http://www.gzns.gov.cn/zwgk/zwdt/content/post_10474418.html'},
          //  {url:require('../../public/static/pageFourth/news1.png'),title:"广州南沙打出金融开放创新“组合拳”",content:'8月13日，广州南沙“金融30条”专项政策宣讲暨金融开放与创新发展大会在南沙国际会展中心举行。',time:'2025-08-14',link:'https://www.gd.gov.cn/gdywdt/zwzt/ygadwq/zdhzpt/ns/content/post_4758375.html'},
          //  {url:require('../../public/static/pageFourth/news1.png'),title:"深度关注 | 大湾区 大未来_南粤清风网",content:'深度关注 | 大湾区 大未来_南粤清风网',link:'https://www.gdjct.gd.gov.cn/zhyw/content/post_204311.html'},






         ]
       };
     },
     methods: {
      goNews(url){
        window.open(url, '_blank');
      },
       handleClick(tab, event) {
         console.log(tab, event);
         if(tab.index==0){
           // 路径跳转
this.$router.push('../view/PageOne.vue')
         }
       }
     }
   };
 </script> 
  <style scoped>
  .item2{
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    padding: 10px 0;
    text-align: left;
    margin-left: 40px;
    font-size: 16px;
color: #7D858F;
  }
  .newsMain:hover {
  cursor: pointer; /* 标准手型光标 */
}
</style>